<script setup lang="ts">
/**
 * UI-kit component
 * Category: Typography
 * Name: 'Body 4/Regular'
 * FIGMA: 'https://www.figma.com/design/CFyOwQUjj7uVRQTc03muvG/Demo-CS?node-id=216-126917&m=dev'
*/

defineOptions({
  name: 'TextQuaternary',
})

withDefaults(defineProps<TextQuaternaryProps>(), {
  is: 'div',
  color: 'default',
  underline: false,
})

interface TextQuaternaryProps {
  is?: 'div' | 'p' | 'span'
  color?: 'default' | 'indigo'
  underline?: boolean
}
</script>

<template>
  <component
    :is="is"
    :class="['p-text-quaternary', { underline }, color]"
  >
    <slot />
  </component>
</template>

<style scoped lang="scss" src="@scss/components/UI/Typography/TextQuaternary.scss" />
